import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';
import { SupportedLanguage } from '@app/utils/constants/supported-languages';

@Injectable({
  providedIn: 'root',
})
export class CustomDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    switch (this.locale) {
      case SupportedLanguage.En:
      case SupportedLanguage.Ko:
      case SupportedLanguage.Pt:
      case SupportedLanguage.ZhHant:
        return 0; // Sunday
      case SupportedLanguage.Es:
      case SupportedLanguage.Ja:
      case SupportedLanguage.ZhHans:
      default:
        return 1; // Monday
    }
  }
}
